import Loading from './src/Loading'
import _LoadingMobile from './src/LoadingMobile'

export const LoadingMobile = _LoadingMobile
export default Loading
